'use client';

import { useSyncExternalStore } from 'react';

import { DEFAULT_DESIGN } from '../config';
import { designs } from '../registry';

import { readDesign, setDesign, subscribeDesign } from './store';

const getServerDesign = () => DEFAULT_DESIGN;

/**
 * The active design and a setter. Renders the default design on the server and during
 * hydration, then the visitor's design — so only client-side behaviour (motion, menus) should
 * depend on it. Markup that differs per design goes through `<DesignOnly>` instead.
 */
export function useDesign() {
  const id = useSyncExternalStore(subscribeDesign, readDesign, getServerDesign);
  return { id, design: designs[id], setDesign };
}
